import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 16px;
  background-color: var(--gray100);
  border-radius: 8px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    display: flex;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
  }
  svg {
    margin-left: 8px;
  }
`
